import { Stack } from '@mui/material';

import { HelpOutlineIcon, Tooltip, Typography } from '@occc-app/design-system';

export type MetricInfoProps = {
  value: number | string;
  dailyAverage?: number;
  tooltipText: string;
  title: string;
};

export const MetricInfo = ({ title, value, dailyAverage, tooltipText }: MetricInfoProps) => {
  return (
    <Stack direction='column'>
      <Stack direction='row' alignItems='center'>
        <Typography variant='body2' color='textSecondary' mr={0.5}>
          {title}
        </Typography>
        <Tooltip title={tooltipText} placement='top'>
          <HelpOutlineIcon sx={{ height: 16, width: 16, color: 'text.secondary' }} />
        </Tooltip>
      </Stack>

      <Stack direction='row' alignItems='baseline' mt={0.5}>
        <Typography component='span'>{value}</Typography>
      </Stack>

      {typeof dailyAverage === 'number' && dailyAverage >= 1 && (
        <Stack direction='row'>
          <Typography variant='body2'>{Math.floor(dailyAverage)}</Typography>

          <Typography variant='body2' color='textSecondary' ml={0.5}>
            Daily Avg
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};
